import { getOnboardRequestDetails } from 'services';
import { useNavigate } from 'react-router';

export const useReviewHandler = () => {
    const navigate = useNavigate();

    const handleReview = (id: number, tabValue: number) => {
        getOnboardRequestDetails(id)
            .then((res: any) => {
                if (res.status === 200) {
                    navigate('/home/review-client-request', {
                        state: {
                            requestData: res.data,
                            tabValue,
                            id
                        }
                    });
                }
            });
    };

    return { handleReview };
};